import { getIsCalendarGridMultiDayItem } from '../../../CalendarGrid.utils'
import { CALENDAR_GRID_WEEK_GRID_LINE_OFFSET } from '../CalendarGridWeekAllDay.constants'

export function getCalendarGridSingleDayItems(items) {
  return items.filter(item => !getIsCalendarGridMultiDayItem(item))
}

export function getIsCalendarGridLaneItemDragDisabled({ canMoveItems, item }) {
  const isItemDraggable = Boolean(item.isDraggable || item.isLaneDraggable)

  return !canMoveItems || !isItemDraggable
}

export function getCalendarGridWeekAllDayCellStyle({ dayIndex, spanCount }) {
  return {
    '--calendar-grid-day-column':
      dayIndex + CALENDAR_GRID_WEEK_GRID_LINE_OFFSET,
    '--calendar-grid-span-tracks': spanCount,
  }
}
